import { FC } from 'react'
import { Button, Dialog } from '@zoom/react-ui'
import { useAppDispatch } from '../../hooks'
import { closeDialog } from '../../app/dialog'

type JoinErrorDialog = {
  content: string
  title: string
}

const JoinErrorDialog: FC<JoinErrorDialog> = ({ title, content }) => {
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(closeDialog())
  }

  return (
    <Dialog
      title={title}
      onCancel={handleClose}
      onEscapeKeyDown={handleClose}
      onBackdropClick={handleClose}
      closable
      footer={
        <div className='footer'>
          <div>
            <Button
              type='primary'
              sx={{ marginRight: '0px !important' }}
              onClick={() => {
                handleClose()
              }}
            >
              Back to Home
            </Button>
          </div>
        </div>
      }
    >
      {content}
    </Dialog>
  )
}

export default JoinErrorDialog
